/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


// Dropdown Text In PDP page
document.querySelectorAll(".dropdown-text-inner").forEach((button, index) => {
  button.addEventListener("click", () => {
    const target = document.querySelectorAll(".dropdown-text-inner")[index];
    target.classList.toggle("active");
  });
});



var GlooiCarousel = class extends HTMLElement {
    async connectedCallback() {
        this.mainCarousel = this.querySelector("flickity-carousel");
        
        this.mainCarousel.addEventListener("flickity:ready", this._onFlickityReady.bind(this));
        this.mainCarousel.addEventListener("flickity:slide-settled", this._onFlickitySettled.bind(this));
        window.addEventListener("resize", this._onResize.bind(this));
    }

    async _onFlickitySettled() {
        const flickityInstance = await this.mainCarousel.flickityInstance;
        flickityInstance.playPlayer();
    }

    async _onResize() {
        const flickityInstance = await this.mainCarousel.flickityInstance;
        if (window.innerWidth >= 1000) {
            if (flickityInstance) flickityInstance.destroy();
        } else {
            if (flickityInstance) flickityInstance.destroy();
            this.mainCarousel.reload();
        }
    }

    async _onFlickityReady() {
        if (window.innerWidth >= 1000) {
            const flickityInstance = await this.mainCarousel.flickityInstance;
            if (flickityInstance) flickityInstance.destroy();
        }
    }
}
window.customElements.define('glooi-carousel', GlooiCarousel);

// custom hide show the ATC for the app option set
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const farbeParent = document.getElementById("farbeParent");
    const addTocart = document.getElementById("AddToCart");
    if (farbeParent) {
      addTocart.parentElement.classList.add("active-options")
    } else {
      if(addTocart.parentElement.classList.contains("active-options")){
        addTocart.parentElement.classList.remove("active-options");
      } else{}
    }
  }, 3000);
});
// custom hide show the ATC for the app option set


/* Swipe Product Images on Dot Click (Product Cards) */
// const navDots = document.querySelectorAll(".image-navigation-dot");
// if (navDots.length > 0) {
//     navDots.forEach((element) => {
//         element.addEventListener("click", function(event) {
//             event.preventDefault();
//             const productItemImageWrapper = event.target.closest(".product-item__image-wrapper");
//             if (!element.classList.contains("is-selected")) {
//                 productItemImageWrapper.querySelectorAll(".image-navigation-dot").forEach((item) => item.classList.remove("is-selected"));
//                 element.classList.add("is-selected");
//                 productItemImageWrapper.classList.toggle("show-secondary-image");
//             }
//         });
//     });
// }
// const navDots = document.querySelectorAll(".image-navigation-dot");

// if (navDots.length > 0) {
//     navDots.forEach((element, index) => {
//         element.addEventListener("click", function(event) {
//             event.preventDefault();
//             const productItemImageWrapper = event.target.closest(".product-item__image-wrapper");
//             if (!element.classList.contains("is-selected")) {
//                 productItemImageWrapper.querySelectorAll(".image-navigation-dot").forEach((item) => item.classList.remove("is-selected"));
//                 element.classList.add("is-selected");
//                 productItemImageWrapper.classList.toggle("show-secondary-image");
//             }
//         });

//         // Swipe support
//         const productItemImageWrapper = element.closest(".product-item__image-wrapper");
//         let touchStartX = 0;
//         let touchEndX = 0;

//         productItemImageWrapper.addEventListener("touchstart", (e) => {
//             touchStartX = e.changedTouches[0].screenX;
//         });

//         productItemImageWrapper.addEventListener("touchend", (e) => {
//             touchEndX = e.changedTouches[0].screenX;
//             handleSwipe(productItemImageWrapper);
//         });

//         function handleSwipe(wrapper) {
//             const dots = wrapper.querySelectorAll(".image-navigation-dot");
//             const selectedDot = wrapper.querySelector(".image-navigation-dot.is-selected");
//             let currentIndex = Array.from(dots).indexOf(selectedDot);

//             if (touchEndX < touchStartX - 40 && currentIndex < dots.length - 1) {
//                 // Swipe left: move to next image
//                 updateDot(wrapper, dots[currentIndex + 1]);
//             } else if (touchEndX > touchStartX + 40 && currentIndex > 0) {
//                 // Swipe right: move to previous image
//                 updateDot(wrapper, dots[currentIndex - 1]);
//             }
//         }

//         function updateDot(wrapper, newDot) {
//             wrapper.querySelectorAll(".image-navigation-dot").forEach((dot) => dot.classList.remove("is-selected"));
//             newDot.classList.add("is-selected");
//             wrapper.classList.toggle("show-secondary-image");
//         }
//     });
// }



// const imageWrapper = document.querySelectorAll(".product-item__image-wrapper--multiple");
// if (imageWrapper.length > 0) {
//     imageWrapper.forEach((element) => {
//         element.addEventListener("mouseenter", function() {
//             element.querySelector(".image-navigation-dot:last-child").click();
//         });

//         element.addEventListener("mouseleave", function() {
//             element.querySelector(".image-navigation-dot:first-child").click();
//         });
//     });
// }

// document.addEventListener('DOMContentLoaded', function () {
//   setTimeout(() => {
//     const targetElement = document.querySelector('.webyzeProductColors.webyzeProductColorsLarge');
//     const variantBtns = document.querySelectorAll('.swatchProductColor');

//     console.log(variantBtns, "length");

//     if (targetElement && variantBtns.length > 14) {
//       console.log('Target element found');

//       // Add initial class
//       targetElement.classList.add('active-variants');

//       // Create button
//       const button = document.createElement('button');
//       button.className = 'custom-view-more-button';
//       button.setAttribute('data-text-more', 'Mehr Farben anzeigen');
//       button.setAttribute('data-text-less', 'Weniger Farben anzeigen');
//       button.textContent = button.getAttribute('data-text-more');

//       // Insert button
//       targetElement.parentNode.insertBefore(button, targetElement.nextSibling);

//       // Add click event
//       button.addEventListener('click', (event) => {
//         event.preventDefault();
//         targetElement.classList.toggle('view-more');

//         // Now check the toggled state
//         if (targetElement.classList.contains('view-more')) {
//           button.textContent = button.getAttribute('data-text-less');
//         } else {
//           button.textContent = button.getAttribute('data-text-more');
//         }
//       });
//     } else if (targetElement) {
//       targetElement.classList.add('no-shadow');
//     }
//   }, 500);
// });

document.addEventListener('DOMContentLoaded', function () {
  if (!/\/products\//.test(window.location.pathname)) {
    return;
  }

  let handled = false;

  function handleWebyzeVariants(obs) {
    if (handled) {
      return;
    }

    const targetElement = document.querySelector('.webyzeProductColors.webyzeProductColorsLarge');
    const variantBtns = document.querySelectorAll('.swatchProductColor');

    if (!targetElement) {
      return;
    }

    handled = true;
    if (obs) {
      obs.disconnect();
    }

    if (variantBtns.length > 14) {
      targetElement.classList.add('active-variants');

      if (!document.querySelector('.custom-view-more-button')) {
        const button = document.createElement('button');
        button.className = 'custom-view-more-button';
        button.setAttribute('data-text-more', 'Mehr Farben anzeigen');
        button.setAttribute('data-text-less', 'Weniger Farben anzeigen');
        button.textContent = button.getAttribute('data-text-more');

        targetElement.parentNode.insertBefore(button, targetElement.nextSibling);

        button.addEventListener('click', (event) => {
          event.preventDefault();
          targetElement.classList.toggle('view-more');

          if (targetElement.classList.contains('view-more')) {
            button.textContent = button.getAttribute('data-text-less');
          } else {
            button.textContent = button.getAttribute('data-text-more');
          }
        });
      }
    } else {
      targetElement.classList.add('no-shadow');
    }
  }

  handleWebyzeVariants();

  if (handled) {
    return;
  }

  const observer = new MutationObserver(function (_mutations, obs) {
    handleWebyzeVariants(obs);
  });

  const productRoot = document.querySelector('.product, .shopify-section--main-product, main');
  const observeTarget = productRoot || document.body;

  observer.observe(observeTarget, {
    childList: true,
    subtree: true,
  });

  window.setTimeout(function () {
    observer.disconnect();
  }, 5000);
});

/**
 * SE Wishlist Engine: Badge im Header nutzt data-total="0" zum Ausblenden.
 * Die App aktualisiert oft nur den Text — data-total bleibt dann auf 0.
 */
(function () {
  const BADGE_SELECTOR = '.wishlist-total-count';
  let syncing = false;
  let debounceTimer = null;

  function parseWishlistCount(badge) {
    const fromAttr = parseInt(badge.getAttribute('data-total'), 10);
    const fromText = parseInt(badge.textContent.trim(), 10);
    const attrCount = Number.isFinite(fromAttr) && fromAttr >= 0 ? fromAttr : 0;
    const textCount = Number.isFinite(fromText) && fromText >= 0 ? fromText : 0;

    return Math.max(attrCount, textCount);
  }

  function syncWishlistBadges() {
    if (syncing) {
      return;
    }

    syncing = true;

    document.querySelectorAll(BADGE_SELECTOR).forEach((badge) => {
      const count = parseWishlistCount(badge);
      const countText = String(count);
      const hide = count <= 0;
      const ariaHidden = hide ? 'true' : 'false';

      if (badge.textContent.trim() !== countText) {
        badge.textContent = countText;
      }

      if (badge.getAttribute('data-total') !== countText) {
        badge.setAttribute('data-total', countText);
      }

      if (badge.hidden !== hide) {
        badge.hidden = hide;
      }

      if (badge.getAttribute('aria-hidden') !== ariaHidden) {
        badge.setAttribute('aria-hidden', ariaHidden);
      }
    });

    syncing = false;
  }

  function scheduleWishlistBadgeSync() {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(() => {
      observeWishlistBadges();
      syncWishlistBadges();
    }, 100);
  }

  function observeWishlistBadges() {
    document.querySelectorAll(BADGE_SELECTOR).forEach((badge) => {
      if (badge.dataset.wishlistBadgeObserved === 'true') {
        return;
      }

      badge.dataset.wishlistBadgeObserved = 'true';
      new MutationObserver(scheduleWishlistBadgeSync).observe(badge, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-total'],
      });
    });
  }

  function initWishlistBadgeSync() {
    observeWishlistBadges();
    syncWishlistBadges();
  }

  document.addEventListener('DOMContentLoaded', initWishlistBadgeSync);

  document.addEventListener('click', (event) => {
    if (event.target.closest('.wishlist-engine, .wishlist-engine-button, .wishlist-page-widget')) {
      window.setTimeout(scheduleWishlistBadgeSync, 50);
      window.setTimeout(scheduleWishlistBadgeSync, 400);
    }
  });

  window.addEventListener('storage', scheduleWishlistBadgeSync);

  ['wishlist:updated', 'wishlist:refresh', 'sewp:wishlist:updated'].forEach((eventName) => {
    document.addEventListener(eventName, scheduleWishlistBadgeSync);
  });
})();

class AnlassHeroCarousel extends HTMLElement {
  static SLIDE_DURATION = 1100;
  static MANUAL_DURATION = 400;
  static SWIPE_DURATION = 400;
  static SWIPE_LOCK_THRESHOLD = 8;
  static SWIPE_COMMIT_RATIO = 0.1;
  static SWIPE_VELOCITY_THRESHOLD = 0.35;
  static AUTOPLAY_RETRY_DELAY = 120;

  connectedCallback() {
    this.viewport = this.querySelector('.anlass-hero-carousel__viewport');
    this.track = this.querySelector('.anlass-hero-carousel__track');
    this.realSlides = [...this.querySelectorAll('[data-anlass-slide]')];

    if (this.realSlides.length <= 1 || !this.viewport || !this.track) {
      return;
    }

    this.realCount = this.realSlides.length;
    this.currentIndex = this.realSlides.findIndex((slide) => slide.classList.contains('is-active'));
    if (this.currentIndex < 0) {
      this.currentIndex = 0;
    }

    this.autoplayInterval = parseInt(this.dataset.autoplayInterval, 10) || 5000;
    this.autoplayEnabled = this.dataset.autoplay !== 'false';
    this._respectReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this._isAnimating = false;
    this._physicalIndex = this.currentIndex + 1;
    this._drag = {
      active: false,
      pointerId: null,
      startX: 0,
      startY: 0,
      startOffset: 0,
      startPhysicalIndex: 1,
      deltaX: 0,
      locked: null,
      samples: [],
      raf: null,
    };

    this._setupInfiniteLoop();
    this._setupSwipe();
    this.updateSlideStates();
    this._moveToPhysical(this._physicalIndex, { animate: false });

    this._onPrev = () => this.onManualNav(-1);
    this._onNext = () => this.onManualNav(1);
    this._onResize = () => this._moveToPhysical(this._physicalIndex, { animate: false });
    this.addEventListener('prev-next:prev', this._onPrev);
    this.addEventListener('prev-next:next', this._onNext);
    window.addEventListener('resize', this._onResize);

    this._onVisibilityChange = () => {
      if (window.__gdnHomepageCarouselSync) {
        return;
      }

      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    };

    this._usesHomepageSync = this.dataset.syncId === 'homepage';

    if (this.autoplayEnabled && !this._respectReducedMotion) {
      if (!this._usesHomepageSync) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
        document.addEventListener('visibilitychange', this._onVisibilityChange);
      }
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();
    if (this._onPrev) {
      this.removeEventListener('prev-next:prev', this._onPrev);
    }
    if (this._onNext) {
      this.removeEventListener('prev-next:next', this._onNext);
    }
    if (this._onResize) {
      window.removeEventListener('resize', this._onResize);
    }
    if (this._onVisibilityChange) {
      document.removeEventListener('visibilitychange', this._onVisibilityChange);
    }
    if (this.viewport && this._onPointerDown) {
      this.viewport.removeEventListener('pointerdown', this._onPointerDown);
      this.viewport.removeEventListener('pointermove', this._onPointerMove);
      this.viewport.removeEventListener('pointerup', this._onPointerUp);
      this.viewport.removeEventListener('pointercancel', this._onPointerCancel);
    }
  }

  _setupInfiniteLoop() {
    const firstSlide = this.realSlides[0];
    const lastSlide = this.realSlides[this.realCount - 1];

    this._cloneFirst = firstSlide.cloneNode(true);
    this._cloneLast = lastSlide.cloneNode(true);
    this._cloneFirst.dataset.anlassSlideClone = 'first';
    this._cloneLast.dataset.anlassSlideClone = 'last';

    [this._cloneFirst, this._cloneLast].forEach((clone) => {
      clone.classList.remove('is-active');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.removeAttribute('data-shopify-editor-block');
    });

    this.track.insertBefore(this._cloneLast, firstSlide);
    this.track.appendChild(this._cloneFirst);
  }

  _setupSwipe() {
    this._onPointerDown = (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) {
        return;
      }

      if (this._isInteractiveTarget(event.target)) {
        return;
      }

      this._prepareManualInteraction();

      this._drag.active = true;
      this._drag.pointerId = event.pointerId;
      this._drag.startX = event.clientX;
      this._drag.startY = event.clientY;
      this._drag.startOffset = this._getCurrentOffset();
      this._drag.startPhysicalIndex = this._physicalIndex;
      this._drag.deltaX = 0;
      this._drag.locked = null;
      this._drag.samples = [{ x: event.clientX, t: performance.now() }];

      this.viewport.setPointerCapture(event.pointerId);
      this.viewport.classList.add('is-dragging');
      this.track.classList.add('is-dragging');
    };

    this._onPointerMove = (event) => {
      if (!this._drag.active || event.pointerId !== this._drag.pointerId) {
        return;
      }

      const deltaX = event.clientX - this._drag.startX;
      const deltaY = event.clientY - this._drag.startY;

      if (!this._drag.locked) {
        if (
          Math.abs(deltaX) < AnlassHeroCarousel.SWIPE_LOCK_THRESHOLD &&
          Math.abs(deltaY) < AnlassHeroCarousel.SWIPE_LOCK_THRESHOLD
        ) {
          return;
        }

        this._drag.locked = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';

        if (this._drag.locked === 'x') {
          this.viewport.style.touchAction = 'none';
        }
      }

      if (this._drag.locked === 'y') {
        return;
      }

      event.preventDefault();
      this._drag.deltaX = deltaX;

      const now = performance.now();
      this._drag.samples.push({ x: event.clientX, t: now });
      this._drag.samples = this._drag.samples.filter((sample) => now - sample.t <= 120);

      if (this._drag.raf) {
        return;
      }

      this._drag.raf = window.requestAnimationFrame(() => {
        this._drag.raf = null;
        this._applyDragOffset(this._drag.deltaX);
      });
    };

    this._onPointerUp = (event) => {
      if (!this._drag.active || event.pointerId !== this._drag.pointerId) {
        return;
      }

      this._finishDrag();
    };

    this._onPointerCancel = (event) => {
      if (!this._drag.active || event.pointerId !== this._drag.pointerId) {
        return;
      }

      this._finishDrag(true);
    };

    this.viewport.addEventListener('pointerdown', this._onPointerDown);
    this.viewport.addEventListener('pointermove', this._onPointerMove, { passive: false });
    this.viewport.addEventListener('pointerup', this._onPointerUp);
    this.viewport.addEventListener('pointercancel', this._onPointerCancel);
  }

  _isInteractiveTarget(target) {
    if (target.closest('.anlass-hero__media-link')) {
      return false;
    }

    return !!target.closest('a, button, input, select, textarea, label, [role="button"]');
  }

  _getCurrentOffset() {
    const transform = window.getComputedStyle(this.track).transform;

    if (!transform || transform === 'none') {
      return this.viewport.clientWidth * this._physicalIndex;
    }

    const matrix = new DOMMatrix(transform);
    return Math.max(0, -matrix.m41);
  }

  _syncPositionFromVisual() {
    const width = this.viewport.clientWidth;
    if (!width) {
      return;
    }

    const nearestPhysical = Math.max(
      0,
      Math.min(this.realCount + 1, Math.round(this._getCurrentOffset() / width))
    );

    this._physicalIndex = nearestPhysical;
    this._syncLogicalFromPhysical();
    this.updateSlideStates();
  }

  _syncLogicalFromPhysical() {
    if (this._physicalIndex === 0) {
      this.currentIndex = this.realCount - 1;
      return;
    }

    if (this._physicalIndex === this.realCount + 1) {
      this.currentIndex = 0;
      return;
    }

    this.currentIndex = this._physicalIndex - 1;
  }

  _getReleaseVelocity() {
    const samples = this._drag.samples;
    if (samples.length < 2) {
      return 0;
    }

    const first = samples[0];
    const last = samples[samples.length - 1];
    const elapsed = last.t - first.t;

    if (elapsed <= 0) {
      return 0;
    }

    return (last.x - first.x) / elapsed;
  }

  _getSwipeDirection() {
    const width = this.viewport.clientWidth;
    if (!width) {
      return 0;
    }

    const progress = -this._drag.deltaX / width;
    const velocity = this._getReleaseVelocity();

    if (
      progress >= AnlassHeroCarousel.SWIPE_COMMIT_RATIO ||
      velocity <= -AnlassHeroCarousel.SWIPE_VELOCITY_THRESHOLD
    ) {
      return 1;
    }

    if (
      progress <= -AnlassHeroCarousel.SWIPE_COMMIT_RATIO ||
      velocity >= AnlassHeroCarousel.SWIPE_VELOCITY_THRESHOLD
    ) {
      return -1;
    }

    return 0;
  }

  _applyDragOffset(deltaX) {
    const offset = this._drag.startOffset - deltaX;
    this.track.style.transform = `translate3d(-${offset}px, 0, 0)`;
  }

  _resetDragState() {
    if (this._drag.raf) {
      window.cancelAnimationFrame(this._drag.raf);
      this._drag.raf = null;
    }

    this.viewport.classList.remove('is-dragging');
    this.track.classList.remove('is-dragging');
    this.viewport.style.touchAction = '';
    this._drag.active = false;
    this._drag.pointerId = null;
    this._drag.locked = null;
    this._drag.samples = [];
  }

  _finishDrag(cancelled = false) {
    if (this.viewport.hasPointerCapture(this._drag.pointerId)) {
      this.viewport.releasePointerCapture(this._drag.pointerId);
    }

    const locked = this._drag.locked;
    const startPhysicalIndex = this._drag.startPhysicalIndex;
    this._resetDragState();

    if (cancelled || locked === 'y') {
      this._moveToPhysical(startPhysicalIndex, {
        animate: !this._respectReducedMotion,
        duration: AnlassHeroCarousel.SWIPE_DURATION,
        snap: true,
      });
      this._restartAutoplayIfNeeded();
      return;
    }

    const direction = this._getSwipeDirection();

    if (direction === 0) {
      this._moveToPhysical(startPhysicalIndex, {
        animate: !this._respectReducedMotion,
        duration: AnlassHeroCarousel.SWIPE_DURATION,
        snap: true,
      });
      this._restartAutoplayIfNeeded();
      return;
    }

    this.onManualNav(direction);
  }

  _emitManualNav(delta) {
    this.dispatchEvent(
      new CustomEvent('gdn:carousel-manual', { bubbles: true, detail: { delta } })
    );
  }

  _clearAnimation(runPendingCallback = false) {
    if (this._animationTimer) {
      window.clearTimeout(this._animationTimer);
      this._animationTimer = null;
    }

    const pendingCallback = runPendingCallback ? this._animationCallback : null;
    this._animationCallback = null;
    this._isAnimating = false;
    this.track.classList.remove('is-sliding', 'is-snapping');

    if (pendingCallback) {
      pendingCallback();
    }
  }

  _restartAutoplayIfNeeded() {
    if (window.__gdnHomepageCarouselSync) {
      window.__gdnHomepageCarouselSync.resetSchedule();
      return;
    }

    if (this.autoplayEnabled && !this._respectReducedMotion) {
      this.startAutoplay();
    }
  }

  _prepareManualInteraction() {
    this.stopAutoplay();
    this._clearAnimation(false);
    this._syncPositionFromVisual();
  }

  _logicalToPhysical(logicalIndex) {
    return logicalIndex + 1;
  }

  _moveToPhysical(physicalIndex, options = {}) {
    const {
      animate = false,
      duration = AnlassHeroCarousel.SLIDE_DURATION,
      snap = false,
      callback = null,
    } = options;

    if (animate && !this._respectReducedMotion) {
      if (this._animationTimer) {
        window.clearTimeout(this._animationTimer);
        this._animationTimer = null;
      }

      this._animationCallback = callback;
      this.track.style.setProperty('--carousel-slide-duration', `${duration}ms`);
      this.track.classList.remove('is-sliding', 'is-snapping');
      this.track.classList.add(snap ? 'is-snapping' : 'is-sliding');
      this._isAnimating = true;
      this._animationTimer = window.setTimeout(() => {
        const completedCallback = this._animationCallback;
        this._clearAnimation(false);
        if (completedCallback) {
          completedCallback();
        }
      }, duration);
    } else {
      this._clearAnimation(false);
    }

    const offset = this.viewport.clientWidth * physicalIndex;
    this.track.style.transform = `translate3d(-${offset}px, 0, 0)`;
    this._physicalIndex = physicalIndex;

    if (!animate && callback) {
      callback();
    }
  }

  onManualNav(delta, options = {}) {
    this._prepareManualInteraction();
    this.advance(delta, {
      duration: options.duration ?? AnlassHeroCarousel.MANUAL_DURATION,
      snap: true,
    });
    this._emitManualNav(delta);
    this._restartAutoplayIfNeeded();
  }

  startAutoplay() {
    this.stopAutoplay();
    if (!this.autoplayEnabled || this._respectReducedMotion || this.realCount <= 1) {
      return;
    }

    if (window.__gdnHomepageCarouselSync) {
      return;
    }

    this._scheduleAutoplayStep(this.autoplayInterval);
  }

  stopAutoplay() {
    if (this._timer) {
      window.clearTimeout(this._timer);
      this._timer = null;
    }
  }

  _scheduleAutoplayStep(delay) {
    this._timer = window.setTimeout(() => {
      if (this._isAnimating) {
        this._scheduleAutoplayStep(AnlassHeroCarousel.AUTOPLAY_RETRY_DELAY);
        return;
      }

      this.advance(1, { duration: AnlassHeroCarousel.SLIDE_DURATION });
      this._scheduleAutoplayStep(this.autoplayInterval);
    }, delay);
  }

  advance(delta, options = {}) {
    const duration = options.duration ?? AnlassHeroCarousel.SLIDE_DURATION;
    const animate = !this._respectReducedMotion;
    const snap = options.snap ?? duration <= AnlassHeroCarousel.MANUAL_DURATION;

    if (delta > 0) {
      if (this.currentIndex < this.realCount - 1) {
        this.currentIndex += 1;
        this.updateSlideStates();
        this._moveToPhysical(this._logicalToPhysical(this.currentIndex), { animate, duration, snap });
        return;
      }

      this.currentIndex = 0;
      this.updateSlideStates();
      this._moveToPhysical(this.realCount + 1, {
        animate,
        duration,
        snap,
        callback: () => {
          this._moveToPhysical(this._logicalToPhysical(this.currentIndex), { animate: false });
        },
      });
      return;
    }

    if (this.currentIndex > 0) {
      this.currentIndex -= 1;
      this.updateSlideStates();
      this._moveToPhysical(this._logicalToPhysical(this.currentIndex), { animate, duration, snap });
      return;
    }

    this.currentIndex = this.realCount - 1;
    this.updateSlideStates();
    this._moveToPhysical(0, {
      animate,
      duration,
      snap,
      callback: () => {
        this._moveToPhysical(this._logicalToPhysical(this.currentIndex), { animate: false });
      },
    });
  }

  updateSlideStates() {
    this.realSlides.forEach((slide, index) => {
      const isActive = index === this.currentIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

      if (isActive) {
        slide.removeAttribute('inert');
      } else {
        slide.setAttribute('inert', '');
      }
    });
  }
}

if (!customElements.get('anlass-hero-carousel')) {
  customElements.define('anlass-hero-carousel', AnlassHeroCarousel);
}

class AnnouncementBarCarousel extends HTMLElement {
  static SLIDE_DURATION = 1100;
  static AUTOPLAY_RETRY_DELAY = 120;

  connectedCallback() {
    this.viewport = this.querySelector('.gdn-announcement-carousel__viewport');
    this.track = this.querySelector('.gdn-announcement-carousel__track');
    this.realSlides = [...this.querySelectorAll('[data-announcement-slide]')];

    if (this.realSlides.length <= 1 || !this.viewport || !this.track) {
      return;
    }

    this.realCount = this.realSlides.length;
    this.currentIndex = 0;
    this.autoplayInterval = (parseInt(this.dataset.autoplayInterval, 10) || 3) * 1000;
    this.autoplayEnabled = this.dataset.autoplay !== 'false';
    this._respectReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this._isAnimating = false;
    this._physicalIndex = 1;

    this._setupInfiniteLoop();
    this._moveToPhysical(this._physicalIndex, { animate: false });

    this._onResize = () => this._moveToPhysical(this._physicalIndex, { animate: false });
    window.addEventListener('resize', this._onResize);

    this._onVisibilityChange = () => {
      if (window.__gdnHomepageCarouselSync) {
        return;
      }

      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    };

    this._usesHomepageSync = this.dataset.syncId === 'homepage';

    if (this.autoplayEnabled && !this._respectReducedMotion && !this._usesHomepageSync) {
      this.startAutoplay();
      document.addEventListener('visibilitychange', this._onVisibilityChange);
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();

    if (this._onResize) {
      window.removeEventListener('resize', this._onResize);
    }

    if (this._onVisibilityChange) {
      document.removeEventListener('visibilitychange', this._onVisibilityChange);
    }
  }

  _setupInfiniteLoop() {
    const firstSlide = this.realSlides[0];
    const lastSlide = this.realSlides[this.realCount - 1];

    this._cloneFirst = firstSlide.cloneNode(true);
    this._cloneLast = lastSlide.cloneNode(true);
    this._cloneFirst.dataset.announcementSlideClone = 'first';
    this._cloneLast.dataset.announcementSlideClone = 'last';

    [this._cloneFirst, this._cloneLast].forEach((clone) => {
      clone.removeAttribute('data-shopify-editor-block');
    });

    this.track.insertBefore(this._cloneLast, firstSlide);
    this.track.appendChild(this._cloneFirst);
  }

  _logicalToPhysical(logicalIndex) {
    return logicalIndex + 1;
  }

  _navigatePhysicalRelative(delta, options = {}) {
    const duration = options.duration ?? AnnouncementBarCarousel.SLIDE_DURATION;
    const animate = options.animate ?? !this._respectReducedMotion;
    const snap = options.snap ?? duration <= AnlassHeroCarousel.MANUAL_DURATION;
    const moveOptions = { ...options, animate, duration, snap };
    const targetPhysical = this._physicalIndex + delta;

    if (targetPhysical >= 1 && targetPhysical <= this.realCount) {
      this.currentIndex = targetPhysical - 1;
      this._moveToPhysical(targetPhysical, moveOptions);
      return;
    }

    if (targetPhysical === 0) {
      this.currentIndex = this.realCount - 1;
      this._moveToPhysical(0, {
        ...moveOptions,
        callback: () => {
          this._moveToPhysical(this._logicalToPhysical(this.currentIndex), { animate: false });
        },
      });
      return;
    }

    if (targetPhysical === this.realCount + 1) {
      this.currentIndex = 0;
      this._moveToPhysical(this.realCount + 1, {
        ...moveOptions,
        callback: () => {
          this._moveToPhysical(this._logicalToPhysical(this.currentIndex), { animate: false });
        },
      });
    }
  }

  _clearAnimation(runPendingCallback = false) {
    if (this._animationTimer) {
      window.clearTimeout(this._animationTimer);
      this._animationTimer = null;
    }

    const pendingCallback = runPendingCallback ? this._animationCallback : null;
    this._animationCallback = null;
    this._isAnimating = false;
    this.track.classList.remove('is-sliding');

    if (pendingCallback) {
      pendingCallback();
    }
  }

  _moveToPhysical(physicalIndex, options = {}) {
    const {
      animate = false,
      duration = AnnouncementBarCarousel.SLIDE_DURATION,
      callback = null,
    } = options;

    if (animate && !this._respectReducedMotion) {
      if (this._animationTimer) {
        window.clearTimeout(this._animationTimer);
        this._animationTimer = null;
      }

      this._animationCallback = callback;
      this.track.style.setProperty('--carousel-slide-duration', `${duration}ms`);
      this.track.classList.add('is-sliding');
      this._isAnimating = true;
      this._animationTimer = window.setTimeout(() => {
        const completedCallback = this._animationCallback;
        this._clearAnimation(false);
        if (completedCallback) {
          completedCallback();
        }
      }, duration);
    } else {
      this._clearAnimation(false);
    }

    const offset = this.viewport.clientWidth * physicalIndex;
    this.track.style.transform = `translate3d(-${offset}px, 0, 0)`;
    this._physicalIndex = physicalIndex;

    if (!animate && callback) {
      callback();
    }
  }

  startAutoplay() {
    this.stopAutoplay();

    if (!this.autoplayEnabled || this._respectReducedMotion || this.realCount <= 1) {
      return;
    }

    if (window.__gdnHomepageCarouselSync) {
      return;
    }

    this._scheduleAutoplayStep(this.autoplayInterval);
  }

  stopAutoplay() {
    if (this._timer) {
      window.clearTimeout(this._timer);
      this._timer = null;
    }
  }

  _scheduleAutoplayStep(delay) {
    this._timer = window.setTimeout(() => {
      if (this._isAnimating) {
        this._scheduleAutoplayStep(AnnouncementBarCarousel.AUTOPLAY_RETRY_DELAY);
        return;
      }

      this.advance(1);
      this._scheduleAutoplayStep(this.autoplayInterval);
    }, delay);
  }

  advance(delta, options = {}) {
    this._navigatePhysicalRelative(delta, options);
  }
}

if (!customElements.get('gdn-announcement-carousel')) {
  customElements.define('gdn-announcement-carousel', AnnouncementBarCarousel);
}

class GdnHomepageCarouselSync {
  static RETRY_DELAY = 120;

  constructor(hero, announcement) {
    this.hero = hero;
    this.announcement = announcement;
    this.interval = hero.autoplayInterval || announcement.autoplayInterval || 3000;
    this.respectReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.paused = false;
    this.timer = null;
  }

  connect() {
    this.hero.stopAutoplay();
    this.announcement.stopAutoplay();

    this._onHeroManual = (event) => {
      const delta = event.detail?.delta ?? 0;
      if (!delta) return;

      this.announcement.advance(delta, {
        animate: !this.respectReducedMotion,
        duration: AnlassHeroCarousel.MANUAL_DURATION,
        snap: true,
      });
      this.resetSchedule();
    };

    this._onHeroMouseEnter = () => this.pause();
    this._onHeroMouseLeave = () => this.resume();
    this._onHeroFocusIn = () => this.pause();
    this._onHeroFocusOut = () => this.resume();
    this._onVisibilityChange = () => {
      if (document.hidden) {
        this.pause();
      } else {
        this.resume();
      }
    };

    this.hero.addEventListener('gdn:carousel-manual', this._onHeroManual);
    this.hero.addEventListener('mouseenter', this._onHeroMouseEnter);
    this.hero.addEventListener('mouseleave', this._onHeroMouseLeave);
    this.hero.addEventListener('focusin', this._onHeroFocusIn);
    this.hero.addEventListener('focusout', this._onHeroFocusOut);
    document.addEventListener('visibilitychange', this._onVisibilityChange);

    if (!this.respectReducedMotion) {
      this.scheduleStep(this.interval);
    }
  }

  pause() {
    this.paused = true;
    this.clearTimer();
  }

  resume() {
    if (!this.paused || this.respectReducedMotion) return;
    this.paused = false;
    this.scheduleStep(this.interval);
  }

  resetSchedule() {
    this.clearTimer();
    if (!this.paused && !this.respectReducedMotion) {
      this.scheduleStep(this.interval);
    }
  }

  clearTimer() {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }

  scheduleStep(delay) {
    this.clearTimer();
    if (this.paused || this.respectReducedMotion) return;

    this.timer = window.setTimeout(() => {
      if (this._isAnyAnimating()) {
        this.scheduleStep(GdnHomepageCarouselSync.RETRY_DELAY);
        return;
      }

      this.step();
      this.scheduleStep(this.interval);
    }, delay);
  }

  _isAnyAnimating() {
    return !!(this.hero._isAnimating || this.announcement._isAnimating);
  }

  step() {
    const duration = AnlassHeroCarousel.SLIDE_DURATION;
    const animate = !this.respectReducedMotion;
    this.hero.advance(1, { duration, animate, snap: false });
    this.announcement.advance(1, { duration, animate, snap: false });
  }
}

function initHomepageCarouselSync() {
  if (window.__gdnHomepageCarouselSync) return;

  const hero = document.querySelector(
    'anlass-hero-carousel[data-sync-id="homepage"][data-autoplay="true"]'
  );
  const announcement = document.querySelector(
    'gdn-announcement-carousel[data-sync-id="homepage"][data-autoplay="true"]'
  );

  if (!hero || !announcement) return;
  if (!hero.realCount || !announcement.realCount) return;
  if (hero.realCount <= 1 && announcement.realCount <= 1) return;

  window.__gdnHomepageCarouselSync = new GdnHomepageCarouselSync(hero, announcement);
  window.__gdnHomepageCarouselSync.connect();
}

function scheduleHomepageCarouselSync() {
  initHomepageCarouselSync();

  window.setTimeout(() => {
    initHomepageCarouselSync();

    if (window.__gdnHomepageCarouselSync) {
      return;
    }

    document
      .querySelectorAll('[data-sync-id="homepage"][data-autoplay="true"]')
      .forEach((carousel) => {
        if (typeof carousel.startAutoplay === 'function') {
          carousel.startAutoplay();
        }
      });
  }, 500);
}

document.addEventListener('DOMContentLoaded', scheduleHomepageCarouselSync);
document.addEventListener('gdn:announcement-bar:mounted', initHomepageCarouselSync);

function clearLegacyGdnChromeState() {
  document.documentElement.classList.remove('gdn-chrome-hidden', 'gdn-chrome-ready', 'gdn-top-category-pinned');

  document.querySelectorAll('.shopify-section-group-header-group').forEach((element) => {
    element.style.transform = '';
  });

  document.querySelectorAll('.shopify-section--top-category .header_top_category').forEach((element) => {
    element.style.top = '';
    element.style.transform = '';
  });

  document.querySelectorAll('.shopify-section--top-category').forEach((element) => {
    element.style.minHeight = '';
  });
}

document.addEventListener('DOMContentLoaded', clearLegacyGdnChromeState);
document.addEventListener('pageshow', clearLegacyGdnChromeState);
document.addEventListener('shopify:section:load', clearLegacyGdnChromeState);

function formatGdnJudgemeBadgeText(badge) {
  if (!badge || badge.dataset.gdnJdgmFormatted === '1') return;

  const textEl = badge.querySelector('.jdgm-prev-badge__text');
  const rating = parseFloat(badge.getAttribute('data-average-rating'));
  const count = parseInt(badge.getAttribute('data-number-of-reviews'), 10);

  if (!textEl || Number.isNaN(rating) || Number.isNaN(count) || count <= 0) return;

  const isPdpBadge = Boolean(badge.closest('.product__info .jdgm-preview-badge'));

  if (isPdpBadge) {
    const ratingLabel = rating.toLocaleString('de-DE', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });
    const countLabel = count === 1 ? 'Bewertung' : 'Bewertungen';
    textEl.textContent = ratingLabel + ' \u00b7 ' + count + ' ' + countLabel;
  } else {
    textEl.textContent = '(' + count + ')';
  }

  badge.dataset.gdnJdgmFormatted = '1';
}

function applyGdnJudgemeBadgeStyle() {
  document.querySelectorAll('.product__info .jdgm-preview-badge .jdgm-star').forEach(function (star) {
    star.style.setProperty('color', '#000', 'important');
  });

  document.querySelectorAll('.product__info .jdgm-preview-badge .jdgm-prev-badge').forEach(function (badge) {
    formatGdnJudgemeBadgeText(badge);

    const textEl = badge.querySelector('.jdgm-prev-badge__text');
    if (!textEl) return;

    textEl.style.setProperty('visibility', 'visible', 'important');
    textEl.style.setProperty('font-weight', '400', 'important');
    textEl.style.setProperty('color', '#000', 'important');
  });
}

function initGdnJudgemeBadgeStyle() {
  if (!document.querySelector('.product__info .jdgm-preview-badge')) {
    return;
  }

  if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
    window.jdgm.customizeBadges();
  }

  applyGdnJudgemeBadgeStyle();
}

document.addEventListener('DOMContentLoaded', function () {
  initGdnJudgemeBadgeStyle();

  if (!document.querySelector('.product__info .jdgm-preview-badge')) {
    return;
  }

  setTimeout(applyGdnJudgemeBadgeStyle, 400);
  setTimeout(applyGdnJudgemeBadgeStyle, 1200);
});

